﻿export const handleAccordions = () => {
    const accordions = document.querySelectorAll('.accordion');
    
    accordions.forEach(accordion => {
        accordion.addEventListener('click', (e: Event) => {
            const target = e.target as HTMLElement;
            
            if (!target.classList.contains('accordion__accordion-heading-container')) {
                return;
            }

            const section = target.parentElement;
            const wasActive = section?.classList.contains('active');
            
            const allSections = accordion.querySelectorAll('.accordion__section');
            allSections.forEach(section => {
                section.classList.remove('active');
                section
                    .querySelector('.accordion__accordion-heading-container')
                    ?.setAttribute('aria-expanded', 'false');
            });

            if (!wasActive) {
                section?.classList.add('active');
                target.setAttribute('aria-expanded', 'true');
            }
        });
    });
};